import React, {Fragment, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {ProductVisibleVoucher} from "./ProductVisibleVoucher";
import {useTranslation} from "react-i18next";

export function PurchaseVoucher({type}: { type: string }) {
  // 임시 처리
  const {t} = useTranslation("consultant");
  const navigate = useNavigate();
  const isThisPageNotShowable = process.env.REACT_APP_MODE === "운영" && type === "counselor";


  useEffect(() => {
    if (isThisPageNotShowable) { // 운영 모드가 아니고 타입이 상담사인 경우
      alert(t("modal.info.desc"))
      navigate('/')
    }
    // eslint-disable-next-line
  }, []);

  const GoToHome = () => {
    return <></>
  }

  return (
      <>
        {isThisPageNotShowable
            ? <GoToHome />
            : <ProductVisibleVoucher type={type} />
        }
      </>
  )

}
